import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import ProductShowcase from "@/components/ProductShowcase";
import CaseStudy from "@/components/CaseStudy";
import ImageBand from "@/components/ImageBand";
import HowItWorks from "@/components/HowItWorks";
import LiveClubs from "@/components/LiveClubs";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import OnboardPage from "@/components/OnboardPage";
import OnboardSuccess from "@/components/OnboardSuccess";
import TermsPage from "@/components/TermsPage";

function MarketingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WhatWeDo />
      <ProductShowcase />
      <CaseStudy />
      <LiveClubs />
      <ImageBand
        src="https://images.unsplash.com/photo-1665413811870-5b29a250f64a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxmYW5zJTIwY2VsZWJyYXRpbmclMjBzdGFkaXVtJTIwY2hlZXJpbmclMjBleGNpdGVtZW50fGVufDB8fHx8MTc3NjQzNTI3OXww&ixlib=rb-4.1.0&q=85"
        alt="Football fans cheering in a stadium"
      />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingPage />} />
        <Route path="/onboard" element={<OnboardPage />} />
        <Route path="/onboard/success" element={<OnboardSuccess />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
